import { Component, Input } from '@angular/core';

@Component({
  selector: 'sha-nav-second',
  templateUrl: './nav-second.component.html',
  styleUrls: ['./nav-second.component.css']
})
export class NavSecondComponent {

  @Input() dataIsLoaded = true;
  @Input() visible = true;

  constructor() { }

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/nav-second/nav-second.component.ts